/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';

/*----------------------------------
- TYPES
----------------------------------*/

export type Props = { children: React.ReactNode };

/*----------------------------------
- COMPONENT
----------------------------------*/
export default function LegacyMantineProvider({ children }: Props) {
    return (
        <MantineProvider withGlobalClasses={false}>
            <DatesProvider settings={{}}>{children}</DatesProvider>
        </MantineProvider>
    );
}
